import Phaser from 'phaser';
import * as C from 'tower/constants';
import BattleScene from '.';
import Room from './room';

export default class Interactable extends Phaser.GameObjects.Sprite {
  declare scene: BattleScene;
  declare body: Phaser.Physics.Arcade.Body;

  constructor(
    scene: Phaser.Scene,
    room: Room,
    x: number,
    y: number,
    texture: string,
    frame: number,
    bodyWidth: number,
    bodyHeight: number,
  ) {
    super(scene, x, y, texture, frame);

    scene.add.existing(this);
    scene.physics.add.existing(this);
    room.interactables.add(this);

    this.setDepth(C.DEPTHS.Items);
    this.body.setSize(bodyWidth, bodyHeight).setImmovable(true);
  }

  interact() {
    this.emit('interact');
  }
}
